import React from "react";
import TourHeader from "../components/tours/TourHeader";
import TourSections from "../components/tours/TourSections";

const ToursMain = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <TourHeader />
      <TourSections />
    </div>
  );
};

export default ToursMain;
